<template>
  <el-row :gutter="5">
    <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
      <el-form-item :label="$t('chave')" prop="key">
        <el-input maxlength="255" ref="key" v-model="ruleForm.key"></el-input>
      </el-form-item>
    </el-col>
    <el-col :xs="15" :sm="10" :md="10" :lg="8" :xl="8">
      <el-form-item :label="$t('token')" prop="token">
        <el-input maxlength="255" v-model="ruleForm.token"></el-input>
      </el-form-item>
    </el-col>
  </el-row>
</template>
<script>

export default {
  name: "ShippingAddFormConfig",
  computed: {
    data() {
      return this.ruleForm;
    }
  },
  methods: {
    setData(ruleForm) {
      this.ruleForm.token = ruleForm.config.token;
      this.ruleForm.key = ruleForm.config.key;
    }
  },
  data() {
    return {
      ruleForm: {
        token: "",
        key: "",
      },
    };
  },
};
</script>
